<template>
  <div id="nav">
    <router-view/>
  </div>
</template>

<style lang="scss">
  #app {
    height: 100vh;
    font-size: 14px;
  }
</style>
